import { Id } from "@dgs/core";
import { ContactAttributeBaseResource } from "../../../../shared/types/contactAttribute";
import { ContactAttribute } from "./contactAttribute";
import { ContactViewOptionResource } from "./contactView";

export enum VCardFieldName {
	ADR = "ADR",
	BDAY = "BDAY",
	EMAIL = "EMAIL",
	GEO = "GEO",
	KEY = "KEY",
	LABEL = "LABEL",
	LANG = "LANG",
	NOTE = "NOTE",
	ORG = "ORG",
	REV = "REV",
	ROLE = "ROLE",
	TEL = "TEL",
	TITLE = "TITLE",
	TZ = "TZ",
	UID = "UID",
	URL = "URL",
}

export interface ProfileContactViewResource {
	id: Id;
	name: string;
	contactAttributes: ContactAttributeBaseResource[];
}

export interface VCardFieldResource {
	name: VCardFieldName;
	contactAttribute: ContactAttribute | null;
}

export interface VCardFieldRequest {
	name: VCardFieldName;
	contactAttributeId: Id | null;
}

export interface ProfileSettingsResource {
	defaultContactView: ContactViewOptionResource;
	vCardFields: VCardFieldResource[];
}
export interface ProfileSettingsRequest {
	defaultContactViewId: Id;
	vCardFields: VCardFieldRequest[];
}
